import styles from "@/components/CustomComponents/StoreLocations/index.module.scss";
import { renderRichText } from "@/utils/formatters";

export default function StoreLocations({ fields }) {
  let storeList = [...fields?.leftContent, ...fields?.rightContent];
  return (
    <div className={styles.wrapper}>
      <section className="max-w-[1120px] mx-auto px-4 py-1 md:py-5">
        <div className="mb-8 ">
          <h2 className="text-3xl font-bold text-gray-900 text-center ">
            {fields?.title}
          </h2>
        </div>

        <div className="grid gap-5 border-b border-gray-200 pb-5 md:grid-cols-2 md:pb-0 lg:grid-cols-3">
          {storeList.map((store, index) => (
            <div
              key={index}
              className="border-b border-gray-200 pb-5 md:border-b-0 bg-white p-3 transition-shadow loc-list"
            >
              {renderRichText(store?.fields?.richText)}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
